import { inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { SMART_COMPARE_INSTRUCTIONS } from 'AgentApp/ts/constants/agent-prompts.constants';
import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';
import { buildContextWrappedPrompt } from 'AgentApp/ts/utils/context-block';
import * as i0 from "@angular/core";
export class AgentSmartCompareService {
    constructor() {
        this._urlsService = inject(UrlsService);
        this._ajaxService = inject(AjaxService);
    }
    getSmartCompareContext(securityIds) {
        const url = this._urlsService.getUrl(this._urlsService.AGENT.SMART_COMPARE_CONTEXT);
        return this._ajaxService.getDataObserveBody(url, {
            security_ids: securityIds.join(','),
        });
    }
    buildSmartComparePrompt(securityIds, promptText) {
        return this.getSmartCompareContext(securityIds).pipe(map(({ context }) => buildContextWrappedPrompt(context, promptText, SMART_COMPARE_INSTRUCTIONS)));
    }
}
AgentSmartCompareService.ɵfac = function AgentSmartCompareService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AgentSmartCompareService)(); };
AgentSmartCompareService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AgentSmartCompareService, factory: AgentSmartCompareService.ɵfac, providedIn: 'root' });
